module.exports = __webpack_public_path__ + "static/media/more-all-products-1.344a35a8.png";